module.exports = __webpack_public_path__ + "img/6-min.1c7a474c.jpg";